import { Component, ElementRef, OnInit, ViewChild,Inject } from '@angular/core';
import { MatDialog,MAT_DIALOG_DATA} from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: 'app-icv-demo-video',
  templateUrl: './icv-demo-video.component.html',
  styleUrls: ['./icv-demo-video.component.scss']
})
export class IcvDemoVideoComponent implements OnInit {
  @ViewChild('videoPlayer') videoPlayer: ElementRef;
  public areControlsVisible:boolean = false;
  public safePdfUrl:any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data:any,
    private dialog:MatDialog,
    private sanitizer: DomSanitizer
  ) {
   }

  ngOnInit(): void {
    // this.safePdfUrl = this.getSafeUrl();
    // console.log(this.data,'data');
  }

  onVideoClick(video: HTMLVideoElement): void {
    if (!this.areControlsVisible) {
      this.areControlsVisible = true;
      setTimeout(() =>{
        video.play();
      },100)
    }
  }

  onCloseVideoPlayer(){
    if(this.videoPlayer){
      this.videoPlayer.nativeElement.pause();
    }
    this.dialog.closeAll();

  }

  getSafeUrl(){
    return this.sanitizer.bypassSecurityTrustResourceUrl("https://s3-ap-southeast-1.amazonaws.com/blogimages.crownit.in/1742472255_webpageICV.pdf");
  }

}
